export default __webpack_public_path__ + "static/media/category_1.8e5f5294.png";